import React, { useEffect } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllRootCategories } from "../../Redux/AllSlices/categories";

export default function CategoryCards() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { rootcategorieslist: categorieslist } = useSelector(
    (state) => state.categories
  );

  useEffect(() => {
    dispatch(getAllRootCategories());
  }, [dispatch]);

  const BaseUrl = process.env.REACT_APP_BASE_URL || "";

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleNavigateToCategory = (category) => {
    if (category?.id) {
      navigate(
        `/products?category=${encodeURIComponent(
          category.title || ""
        )}&category_id=${encodeURIComponent(category.id)}`
      );
    } else if (category?.title) {
      navigate(`/products?category=${encodeURIComponent(category.title)}`);
    } else if (typeof category === "string") {
      navigate(`/products?category=${encodeURIComponent(category)}`);
    }
  };

  return (
    <div className="container mx-auto px-4 py-10 font-archivo">
      <div>
        <Slider {...settings}>
          {categorieslist?.map((category) => (
            <div
              key={category.id}
              className="overflow-hidden cursor-pointer"
              onClick={() => handleNavigateToCategory(category)}
            >
              <div className="aspect-[4/3] relative flex items-center justify-center px-4">
                {category?.image ? (
                  <img
                    src={`${BaseUrl}/${category?.image}`}
                    alt={category?.title || "Category"}
                    loading="lazy"
                    decoding="async"
                    className="object-cover"
                  />
                ) : (
                  <h3>{category?.title}</h3>
                )}
              </div>
              <div className="p-2 text-center border border-black hover:shadow-lg transition-shadow duration-200 mx-3">
                <h3 className="font-bold text-sm">{category?.title}</h3>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
